export default function TabInnerTitle({title}: { title: string }): JSX.Element {
    return <>
        <div className="md:col-span-2 lg:col-span-3 xl:col-span-4 text-succ2 
            uppercase font-normal text-2xl my-2">{title}</div>
    </>
}